module.exports = __webpack_public_path__ + "static/img/industriales2.356b7f7.png";